<template>
    <div class="mainpage">
        <p class="mb-1"> Select CTA type </p>
        <div class="d-flex justify-content-start mb-3">
            <div v-for="(cta) in ctaTypes" :key="cta.value" class="griditem">
                <div :class="['ctaType' ,cta.value===currentCtaType ? 'ctaSelected' : '']" @click="changeCtaType(cta.value)">
                    <img class="mx-2" :src="cta.image"/>
                    <p class="ctaTypeText">{{ cta.label}}</p>
                </div>
            </div>
        </div>
        <div v-if="currentCtaType === 'url'" class="d-flex mb-3">
            <div class="d-flex align-items-center">
                <RadioButton v-model="urlFileType" inputId="subType1" name="static" value="static" />
                <label for="subType1" class="mx-2">Static</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="urlFileType" inputId="subType2" name="dynamic" value="dynamic" />
                <label for="subType2" class="mx-2">Dynamic</label>
            </div>
            <!-- <div class="d-flex align-items-center">
                <RadioButton v-model="subType" inputId="subType1" name="others" value="others" />
                <label for="subType1" class="mx-2">Others</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="subType" inputId="subType2" name="whatsapp" value="wp" />
                <label for="subType2" class="mx-2">Whatsapp Links</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="subType" inputId="subType3" name="apk" value="apk" />
                <label for="subType3" class="mx-2">APK Links</label>
            </div> -->
        </div>
        <div v-if="currentCtaType === 'mobile'" class="d-flex mb-3">
            <div class="d-flex align-items-center">
                <RadioButton v-model="subType" inputId="subType4" name="mobile" value="mob" />
                <label for="subType4" class="mx-2">Mobile</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="subType" inputId="subType5" name="landline" value="ll" />
                <label for="subType5" class="mx-2">Landline</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="subType" inputId="subType6" name="tollfree" value="tf" />
                <label for="subType6" class="mx-2">Toll free</label>
            </div>
            <div class="d-flex align-items-center mx-2">
                <RadioButton v-model="subType" inputId="subType7" name="shortcode" value="sc" />
                <label for="subType7" class="mx-2">Short code</label>
            </div>
        </div>
        <Form @submit="submitCta">
            <div class="input-fields">
                <label class="mb-1" for="bulk-upload">Enter Upload Name </label>
                <Field name="name" :rules="(value) => value !== ''" v-model="uploadName" v-slot="{ field, errors }">
                    <InputText type="text" v-bind="field" placeholder="Upload Name" class="set-width" />
                    <span class="validation-error">{{ errors[0] }}</span>
                </Field>
            </div>
            <div class="mb-3">
                <span>Download {{ currentCtaType === 'url' ? `${urlFileType}` : ''}} sample file </span><i class="pi pi-download ml-1 point" style="margin-left:10px;" @click="downloadSampleFile" ></i>
            </div>
            <div class="white-background">
                <div class="upload-area" @click="openFileInput">
                    <img src="@/assets/images/upload_icon.svg" alt="Upload Icon" class="upload-icon" />
                    <p>Browse Files to Upload</p>
                    <p> ( Upload csv file only | Max file size is 5MB )</p>
                </div>
                <input type="file" ref="fileInput"  accept=".csv" @change="handleFileUpload" style="display: none" />
            </div>
            <div v-show="fileSelected" class="file-upload">
                <i class="pi pi-check-circle"></i>
                <div>{{ this.fileSelected.name }}</div>
                <p v-if="uploadProgress!==100" >Uploading: {{ uploadProgress }}%</p>
                <p v-else >Completed</p>
                <ProgressBar :value="uploadProgress" :showValue="false"></ProgressBar>
            </div>
            <div class="actions-btns" v-if="currentCtaType == 'url'">
                <Checkbox inputId="isChecked" v-model="isChecked" :binary="true" />
                <label for="isVariable" class="mb-0 mx-2 cursor-pointer">
                    {{ registeredDlt === 'VIL' ? vilCheckboxText : bsnlCheckboxText  }}
                </label>
            </div>
            <div class="actions-btns">
                <div class="gap">
                    <Button type="submit" class="mr-3" label="Submit" :disabled="disableSave"/>
                </div>
                <div>
                    <Button label="Cancel" severity="secondary" @click="cancel"/>
                </div>
            </div>
        </Form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels, isValidURL } from '@/utils'
import RadioButton from 'primevue/radiobutton'
import { CTA } from '@/constants'
import Toastr from 'toastr'
import Papa from 'papaparse'
import config from '@/config/config'

export default {
    name: 'Bulk Whitelist',
    components: {
        RadioButton
    },
    data () {
        return {
            ctaTypes: [ { label: 'URL', value: 'url', image: this.$images.whitelisting.url },
                { label: 'Number', value: 'mobile', image: this.$images.whitelisting.mobile },
                { label: 'Email', value: 'email', image: this.$images.whitelisting.email } ],
            currentCtaType: 'url',
            subType: 'lu',
            urlFileType: 'static',
            cta: '',
            sampleUrl: '',
            isVariable: false,
            notShorten: false,
            uploadName: '',
            fileSelected: '',
            uploading: false,
            uploadProgress: 0,
            disableSave: true,
            isChecked: false,
            registeredDlt: config.REGISTERED_DLT,
            bsnlCheckboxText: 'It is hereby confirmed that I have fully complied with all the provisions of TCCCPR 2018 and its amendments. the whitelisted URLs/ APKs/ OTT links are not malicious.',
            vilCheckboxText: 'The whitelisted URLs/ APKs/ OTT links added in the content template registered by us are not malicious.'
        }
    },
    methods: {
        cancel () {
            this.$router.push('/cta')
        },
        downloadSampleFile () {
            if (this.currentCtaType === CTA.URL) {
                this.$store.dispatch('Cta/Whitelist/downloadSampleFile', { url: `/files/${this.currentCtaType}/${this.urlFileType}.csv`, name: `${this.currentCtaType}_${this.urlFileType}_sample.csv` })
            } else if (this.currentCtaType === CTA.EMAIL) {
                this.$store.dispatch('Cta/Whitelist/downloadSampleFile', { url: `/files/${this.currentCtaType}/${this.subType}.csv`, name: `${this.currentCtaType}_sample.csv` })
            } else {
                this.$store.dispatch('Cta/Whitelist/downloadSampleFile', { url: `/files/${this.currentCtaType}/${this.subType}.csv`, name: `${this.currentCtaType}_${this.subType}_sample.csv` })
            }
        },
        async submitCta () {
            if (this.currentCtaType === 'url' && !this.isChecked) {
                let text = this.registeredDlt === 'VIL' ? this.vilCheckboxText : this.bsnlCheckboxText
                Toastr.error(null, `Please tick the checkbox for "${text}".`)
                return
            }
            this.$router.push('/cta/bulk')
            this.globalLoader = false
            this.uploading = true
            try {
                this.$store.dispatch('Cta/Whitelist/uploadFile', { file: this.fileSelected, type: this.currentCtaType, uploadName: this.uploadName, subTypeForCta: this.subType, urlFileType: this.urlFileType })
                this.uploadProgress = 100
            } catch (error) {
                Toastr.error(`Error uploading file`, 'Error')
            }
            this.uploading = false
        },

        async changeCtaType (value) {
            if (value !== this.currentCtaType) {
                if (value === CTA.MOBILE) {
                    this.currentCtaType = value
                    this.subType = 'mob'
                    this.cta = ''
                } else if (value === CTA.URL) {
                    this.currentCtaType = value
                    this.subType = 'lu'
                    this.cta = ''
                    this.urlFileType = 'static'
                } else if (value === CTA.EMAIL) {
                    this.currentCtaType = value
                    this.subType = 'email'
                    this.cta = ''
                }
                this.isVariable = false
                this.notShorten = false
                this.sampleUrl = ''
            }
        },
        isUrl (value) {
            if (!value) {
                return 'This is a required field'
            }
            let test = isValidURL(value)
            if (!test) {
                return 'Please enter a valid URL'
            }
            return true
        },
        isDynamicUrl (value) {
            if (!value) {
                return 'This is a required field'
            }
            let test = isValidURL(value)
            if (!test) {
                return 'Please enter a valid URL'
            } else if (this.isVariable && value[value.length - 1] !== ('?')) {
                return 'Dynamic URL should have ? at end'
            }
            return true
        },
        isNumber (value) {
            if (!value) {
                return 'This is a required field'
            }
            return true
        },
        handleFileUpload (event) {
            this.fileSelected = event.target.files[0]
            this.uploading = true
            this.uploadProgress = 0
            if (this.fileSelected && this.fileSelected.name.toLowerCase().endsWith('.csv')) {
                this.checkCSVRowCount(this.fileSelected).then(isValid => {
                    if (isValid) {
                        this.uploadProgress = 100
                        this.disableSave = false
                    } else {
                        this.fileSelected = ''
                        Toastr.error('CSV file has more than 500 rows. Please upload a smaller file.', 'Error')
                    }
                }).catch(error => {
                    this.fileSelected = ''
                    Toastr.error(`Error parsing CSV: ${error.message}`, 'Error')
                })
            } else {
                this.fileSelected = ''
                Toastr.error('Unsupported file format', 'Error')
            }
        },
        checkCSVRowCount (file) {
            return new Promise((resolve, reject) => {
                let rowCount = 0
                Papa.parse(file, {
                    header: true,
                    step: (results, parser) => {
                        rowCount++
                        if (rowCount > 500) {
                            parser.abort()
                            resolve(false)
                        }
                    },
                    complete: () => {
                        resolve(rowCount <= 500)
                    },
                    error: (error) => {
                        reject(error)
                    },
                    skipEmptyLines: true
                })
            })
        },
        openFileInput () {
            this.$refs.fileInput.click()
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader', 'subscription']),
        ...mapGetters('Cta/Whitelist', ['getbulkCtaList'])
    },
    mounted () {
    }
}
</script>

<style>
.ctaType {
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    width: 150px;
    height: 50px;
    padding: 5px 2px;
    border-radius: 5px ;
    cursor: pointer;
    margin-right: 0.5rem;
}
.ctaSelected {
    border: 1px solid black;
}
.ctaTypeText{
    text-align: center;
    color: black;
    font-size: 0.875rem;
    font-weight: 800;
    line-height: 1rem;
    margin: 0px;
}
.ctaType:hover {
    border: 1px solid black;
}
.input-fields {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
}
.actions-btns {
    margin-bottom: 1rem;
    display: flex;
    justify-content: start;
}
.info-btn {
    color: var(--primary-color);
}
.tooltip-class {
    width: initial !important;
    min-width: 400px
}
.set-width {
    width: 40%;
}
.white-background {
    padding: 2rem;
    background-color: white;
    border-radius: 1rem;
    min-height: 30vh;
    margin-bottom: 1rem;
    text-align: center;
    padding: 30px;
    cursor: pointer;
    padding-top: 5rem;
}
.file-upload {
    padding: 2rem;
    background-color: white;
    border-radius: 1rem;
    margin: 1rem;
    width: 30%;
}
/* .help-bg {
    border-radius: 5px;
    background-color: rgba(255, 193, 7, 0.2);
} */
</style>
